<template>
    <div class="flex-column" :class="{center, shrink }">
        <slot></slot>
    </div>
</template>
<script>

export default {
    props:{
        center:{
            type:Boolean
        },
        shrink:{
            type:Boolean
        },
    },
}

</script>
<style scoped lang="scss">
.flex-column {
    display: flex;
    overflow: hidden;
    flex: 1;
    flex-direction: column;

    &.center {
    	align-items: center;
    	justify-content: center;
    }

    &.shrink {
        flex:none;
    }
}



</style>